import { useEffect } from "react";
import { Refine } from "@pankod/refine-core";
import {
  Icons,
  ConfigProvider,
  notificationProvider,
  // ReadyPage,
  ErrorComponent,
  // LoginPage,
} from "@pankod/refine-antd";
import uk_UA from "antd/lib/locale/uk_UA";
import ru_RU from "antd/lib/locale/ru_RU";
import en_US from "antd/lib/locale/en_US";

import dayjs from "dayjs";
import "dayjs/locale/uk";
import "dayjs/locale/ru";

import { DashboardPage } from "./pages/dashboard";
import { LoginPage } from "./pages/login";
import { OrganizationList, OrganizationCreate, OrganizationEdit } from "./pages/organizations";
import { StoreList, StoreCreate, StoreEdit } from "./pages/stores";
import { SalesList, SaleShow } from "./pages/sales";
import { OrderList } from "./pages/orders";
import { UserList } from "./pages/users";
import { CategoryList } from "./pages/categories";
import { RoomList } from "./pages/rooms";

import { BikeWhiteIcon } from "./components/icons";

import routerProvider from "@pankod/refine-react-router-v6";
import { dataProvider } from "@pankod/refine-supabase";
import { RefineKbarProvider } from "@pankod/refine-kbar";
import { useTranslation } from "react-i18next";
import "styles/antd.less";
import { supabaseClient } from "utility";
import {
  Title,
  Header,
  Sider,
  // Footer,
  Layout,
  OffLayoutArea,
} from "components/layout";
import authProvider from "./authProvider";

function App() {
  const { t, i18n } = useTranslation();

  const i18nProvider = {
    translate: (key: string, params: object) => t(key, params),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };
  const locale = i18nProvider.getLocale()
  
  const myLocale = (locale: string ) => {
    switch (locale) {
      case "en":
        return en_US;
      case "uk":
        return uk_UA;
      case "ru":
        return ru_RU;
      default:
        return uk_UA;
        // return en_US;
        // return undefined;
    }
  } 

  useEffect(() => {
    switch (locale) {
    case "en":
      dayjs.locale("en");
      break;
    case "uk":
      dayjs.locale("uk");
      break;
    case "ru":
      dayjs.locale("ru");
      break;
    default:  
      dayjs.locale("uk");
      // dayjs.locale("en");
      break;
    }
    // if (locale === "ru") {
    //     dayjs.locale("ru");
    // } else {
    //     dayjs.locale("en");
    // }
  }, [locale]);

  return (
    <RefineKbarProvider>
      {/* <ConfigProvider locale={locale === "ru" ? ru_RU : undefined}> */}
      <ConfigProvider locale={myLocale(locale)}>
        <Refine
          routerProvider={routerProvider}
          dataProvider={dataProvider(supabaseClient)}
          authProvider={authProvider}
          accessControlProvider={{
            can: async ({ resource }) => {
              if (resource !== "users") {
                return { can: true };
              }
              try {
                const role = await authProvider.getPermissions();
                return { can: role === "admin" };
              } catch {
                return { can: false };
              }
            },
          }}
          i18nProvider={i18nProvider}
          OffLayoutArea={OffLayoutArea}
          DashboardPage={DashboardPage}
          // ReadyPage={ReadyPage}
          LoginPage={LoginPage}
          Title={Title}
          Header={Header}
          Layout={Layout}
          syncWithLocation
          warnWhenUnsavedChanges
          resources={[
            {
              name: "orders",
              list: OrderList,
              // show: OrderShow,
              icon: <Icons.ShoppingOutlined />,
            },
            {
              name: "sales",
              list: SalesList,
              show: SaleShow,
              icon:<Icons.DeliveredProcedureOutlined />
            },
            {
              name: "stores",
              list: StoreList,
              edit: StoreEdit,
              create: StoreCreate,
              icon: <Icons.ShopOutlined />,
            },
            {
              name: "organizations",
              list: OrganizationList,
              create: OrganizationCreate,
              edit: OrganizationEdit,
              icon: <Icons.IdcardOutlined />
              // icon: <Icons.StarOutlined />
            },
            {
              name: "users",
              list: UserList,
              // show: UserShow,
              icon: <Icons.UsergroupAddOutlined />,
            },
            {
              name: "categories",
              list: CategoryList,
            },
            {
              name: "rooms",
              list: RoomList,
              icon: <BikeWhiteIcon />,
            },
                        // // {
                        // //     name: "products",
                        // //     // list: ProductList,
                        // //     icon: <PizzaIcon />,
                        // // },            
                        // {
                        // // {
                        // //     name: "couriers",
                        // //     // list: CourierList,
                        // //     // show: CourierShow,
                        // //     // create: CouriersCreate,
                        // //     // edit: CouriersEdit,
                        // //     icon: <BikeWhiteIcon />,
                        // // },
                        // {
                        //     name: "reviews",
                        //     // list: ReviewsList,
                        //     icon: <Icons.StarOutlined />,
                        // },
                    ]}
          notificationProvider={notificationProvider}
          catchAll={<ErrorComponent />}
          Sider={Sider}
          // Footer={Footer}
          disableTelemetry={true}
        />
      </ConfigProvider>
    </RefineKbarProvider>
  );
}

export default App;
